<template>
  <div class="module_title">
    <span class="home_about_title">
      <span class="home_about_title1">{{title}}</span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '招聘',
    },
   
  }
}
</script>

<style lang="scss" scoped>
  .module_title{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    /* background-color: #0098FF; */
    /* text-align: center; */
  }
  .home_about_title{
    width: 150px;
    font-size: 36px;
    line-height: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    padding-bottom: 20px;
    margin-bottom: 20px;
    text-align: center;
  }
  .home_about_title1{
    color: #0098FF;
    font-size: 24px;
    line-height: 24px;
    margin-bottom: 24px;
  }
  
  @media screen and (max-width: 768px) {
    .home_about_title{
      width: 400px;
      font-size: 90px;
      line-height: 90px;
      font-family: PingFang SC;
      font-weight: 500;
      padding-bottom: 20px;
      margin-bottom: 20px;
      text-align: center;
    }

    .home_about_title1{
      color: #0098FF;
      font-size: 60px;
      line-height: 24px;
      margin-bottom:24px;
    }
  }
</style>